import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { actionToAddSkuItemInCart } from "../../actions/cartActions";
import { actionOrderToCheckUnpaidOrders } from "../../actions/orderActions";
import {
  actionToBringInSkuPrice,
  actionToGetCampaignedProductDetails,
  actionToGetProductDetails,
} from "../../actions/productActions";
import { Helmet } from "react-helmet";
import ErcModal from "../../modules/shared/components/ErcModal";
import LoadingBox from "../../modules/shared/components/LoadingBox";
import MessageBox from "../../modules/shared/components/MessageBox";
import "./Campaign.css";
import { CART_EMPTY_SKU } from "../../constants/cartConstants";
import ShippingMessage from "../AdminShippingMessage/ShippingMessage";
import AdvantagesBoard from "../AdvantagesBoard/AdvantagesBoard";
import LoadingBlackOut from "../../modules/shared/components/LoadingBlackOut";
import { actionToGetReviewsList } from "../../actions/reviewActions";
import QnaUserForm from "../Qna/QnaUserForm";
import useScrollRestorationLand from "../../hooks/useScrollRestorationLand";
import useVariantSelection from "../../hooks/useVariantSelection";
import useVariantSelectedSku from "../../hooks/useVariantSelectedSku";
import FreeProductAddToCart from "../NewProductScreen/FreeProductAddToCart";
import useWidth from "../../hooks/useWidth";
import SectContent from "./SectContent";
import useGetLimitedTimeDiscountInfo from "../../hooks/useGetLimitedTimeDiscountInfo";
import { useUpdateCartExtraDiscountPrice } from "../../hooks/useUpdateCartExtraDiscountPrice";
import { useCalculateExtraDiscount } from "../../hooks/useCalculateExtraDiscount";

export default function ProductLandings(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const productId = props.match.params.id;
  const url = props.match.url;
  const urlExtension = props.match.params.urlExt;
  const urlSearch = props.location.search;
  const key = urlSearch.split("=")[0].slice(1);
  const value = urlSearch.split("=")[1];
  const width = useWidth();
  const appealFromUrl =
    location.pathname.split("/")[location.pathname.split("/").length - 1];

  // PROPS COMING FROM App
  const { createdFingerPrint /*cartTotal*/ } = props;

  /* const [showCart, setShowCart] = useState(false);
  useEffect(() => {
    // atcs stands for ADD TO CART SELECTION
    if (url && url.includes("atcs")) {
      setShowCart(true);
    }
  }, [url]);*/

  // SCROLL RESTORATION LOGIC
  useScrollRestorationLand("land");

  // REDUX STATE THAT HOLDS INFO IF THERE IS A PENDING ORDER OF CLIENT
  const checkIfThereIsApendingOrder = useSelector(
    (state) => state.checkIfThereIsApendingOrder
  );
  const { isPending } = checkIfThereIsApendingOrder;

  // SIGN VISITOR AS "landingVisitor"IN SESSION STORAGE
  useEffect(() => {
    if (urlExtension && key && value) {
      sessionStorage.setItem(
        "landingVisitor",
        JSON.stringify({
          url: `${url}`,
          urlExtension: `${urlExtension}`,
          key: `${key}`,
          value: `${value}`,
        })
      );
    } else if (urlExtension) {
      sessionStorage.setItem(
        "landingVisitor",
        JSON.stringify({
          url: `${url}`,
          urlExtension: `${urlExtension}`,
        })
      );
    }
  }, [urlExtension, key, value, url]);

  // BRING IN PRODUCT DETAILS
  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;
  //REQUEST PRODUCT DETAILS FROM SERVER
  useEffect(() => {
    dispatch(actionToGetProductDetails(productId));
  }, [dispatch, productId]);

  // BRING IN FREE PRODUCT DETAILS IF ANY
  const campaignedProductDetails = useSelector(
    (state) => state.campaignedProductDetails
  );
  const {
    loading: loadingCampaign,
    error: errorCampaign,
    product: productCampaign,
  } = campaignedProductDetails;
  useEffect(() => {
    if (!loading && !error && product) {
      if (product.freeProductId) {
        dispatch(actionToGetCampaignedProductDetails(product.freeProductId));
      }
    }
  }, [dispatch, loading, error, product]);

  // GET LIMITED TIME DISCOUNT INFO (remainingTime is in miliseconds)
  const { isDiscountValid, remainingTime } = useGetLimitedTimeDiscountInfo(
    product,
    createdFingerPrint
  );

  //REDUX STATE THAT HOLDS REVIEWS LIST
  const getReviewsList = useSelector((state) => state.getReviewsList);
  const { reviewsList } = getReviewsList;
  useEffect(() => {
    dispatch(actionToGetReviewsList(productId, 5, 20)); // OPTIONAL PARAMETERS AFTER productId IS rating AND count
  }, [dispatch, productId]);

  // ORDER NOW CARD ARRAY
  const [orderNowCards, setOrderNowCards] = useState([]);
  useEffect(() => {
    if (!loading && !error && product) {
      setOrderNowCards([
        {
          qty: product.qtyMultiplierForLandings
            ? 1 * product.qtyMultiplierForLandings
            : 1,
          priceForOne: product.defaultPrice,
          price:
            product.qtyMultiplierForLandings &&
            product.qtyMultiplierForLandings > 1
              ? (
                  product.defaultPriceGap *
                    (product.qtyMultiplierForLandings - 1) +
                  product.defaultPrice
                ).toFixed(2)
              : product.defaultPrice.toFixed(2),
          imageRepeats: ["a"],
          skus: product.skus.map((sku) => sku),
          freeProductSkus: product.freeProductSkus, // This field belongs to main product e.g : Etol
          // This comes from the promoted product (campaign product) : Ped (If main product and promoted are same, freeproductskus is used to determine promoted product)
          freeSkus:
            product.freeProductId &&
            !loadingCampaign &&
            !errorCampaign &&
            productCampaign &&
            productCampaign.skus.map((sku) => sku),
          discounted: false,
        },
        {
          qty: product.qtyMultiplierForLandings
            ? 2 * product.qtyMultiplierForLandings
            : 2,
          priceForOne: product.defaultPrice,
          price:
            product.qtyMultiplierForLandings &&
            product.qtyMultiplierForLandings > 1
              ? (
                  product.defaultPriceGap *
                    (product.qtyMultiplierForLandings * 2 - 1) +
                  product.defaultPrice
                ).toFixed(2)
              : (product.defaultPrice + product.defaultPriceGap).toFixed(2),
          imageRepeats: ["a", "b"],
          skus: product.skus.map((sku) => sku),
          freeProductSkus: product.freeProductSkus,
          freeSkus:
            product.freeProductId &&
            !loadingCampaign &&
            !errorCampaign &&
            productCampaign &&
            productCampaign.skus.map((sku) => sku),
          discounted: true,
        },
        {
          qty: product.qtyMultiplierForLandings
            ? 3 * product.qtyMultiplierForLandings
            : 3,
          priceForOne: product.defaultPrice,
          price:
            product.qtyMultiplierForLandings &&
            product.qtyMultiplierForLandings > 1
              ? (
                  product.defaultPriceGap *
                    (product.qtyMultiplierForLandings * 3 - 1) +
                  product.defaultPrice
                ).toFixed(2)
              : (product.defaultPrice + product.defaultPriceGap * 2).toFixed(2),
          imageRepeats: ["a", "b", "c"],
          skus: product.skus.map((sku) => sku),
          freeProductSkus: product.freeProductSkus,
          freeSkus:
            product.freeProductId &&
            !loadingCampaign &&
            !errorCampaign &&
            productCampaign &&
            productCampaign.skus.map((sku) => sku),
          discounted: true,
        },
      ]);
    }
  }, [
    loading,
    error,
    product,
    loadingCampaign,
    errorCampaign,
    productCampaign,
  ]);

  //************************************************************************************************//

  //REDUX STATE THAT HOLDS CART ITEMS
  const addOrRemoveSkuItemInCart = useSelector(
    (state) => state.addOrRemoveSkuItemInCart
  );
  const { cartSkuItems } = addOrRemoveSkuItemInCart;

  // orderNowWithVariants CARD ARRAY
  // ARRAY THAT HOLDS CHOOSEN VARIANTS
  const [choosenVariants, setChoosenVariants] = useState("");

  // Returns single sku if any and fullVariantsArray
  const variants = useVariantSelection(
    loading,
    error,
    product,
    choosenVariants
  );

  // returns choosen sku
  const multiSku = useVariantSelectedSku(
    variants.fullVariantsArray,
    choosenVariants,
    product,
    actionToBringInSkuPrice
  );

  //REDUX STATE THAT HOLDS PRODUCT SKU DETAILS
  const bringInSkuPrice = useSelector((state) => state.bringInSkuPrice);
  const {
    loading: loadingSkuData,
    error: errorSkuData,
    skuData,
  } = bringInSkuPrice;

  /* With this code we set prices for the choosen sku. Each sku has its own price and name.*/
  const [price, setPrice] = useState({ price: 0, priceGap: 0, name: "" });
  useEffect(() => {
    if (skuData) {
      // SET CHOOSEN SKU PRICES
      setPrice({
        price: skuData.skus[0].price,
        priceGap: skuData.skus[0].priceGap,
        name: skuData.skus[0].name,
      });
    } else if (!loading && !error && product) {
      // SET DEFAULT PRICES
      setPrice({
        price: product.defaultPrice,
        priceGap: product.defaultPriceGap,
        name: product.name,
      });
    }
  }, [error, loading, product, skuData]);

  //REACT STATES THAT MENAGES ALERT IF QTY OR VARIANTS ARE NOT CHOOSEN BEFORE HITTING ADD TO CART BUTTON
  const [variantAlert, setVariantAlert] = useState({ index: -1, message: "" });
  const [noSkuAlert, setNoSkuAlert] = useState("");
  const [qtyAlert, setQtyAlert] = useState("");
  const [qty, setQty] = useState(0);

  // DISABLES AddToCart BUTTON TO AVOID MULTIPLE ADS
  const [disableButton, setDisableButton] = useState(false);
  // OPENS ErcModal IF THERE IS A FREE OFFER
  const [buyOneGetOneFreeRequested, setBuyOneGetOneFreeRequested] =
    useState(false);

  // IF THERE IS A CAMPAIGNED PRODUCT CHECK COUNT IN STOCK. IF THERE IS NO STOCK, DO NOT OPEN BUY ONE GET ONE FREE MODAL
  const [isCampaignedProductInStock, setIsCampaignedProductInStock] =
    useState(false);
  useEffect(() => {
    if (!loadingCampaign && !errorCampaign && productCampaign) {
      const stockNumber = productCampaign.skus
        .map((sku) => sku.countInStock)
        .reduce((a, c) => a + c, 0);
      if (stockNumber > 0) {
        setIsCampaignedProductInStock(true);
      }
    }
  }, [loadingCampaign, errorCampaign, productCampaign]);

  // BUY BUTTON FOR VARIANTS
  const [pendingPush, setPendingPush] = useState(false); // Loading icon while pending to be pushed to order form
  useEffect(() => {
    if (
      (variantAlert && variantAlert.message) ||
      qtyAlert === "Lütfen adet seçiniz"
    )
      return setPendingPush(false);
  }, [variantAlert, qtyAlert]);

  function addToCartHandler(productId, buyOneGetOneFree, discounted) {
    discounted = true;

    setPendingPush(true);

    if (!multiSku && !variants.singleSku) {
      setNoSkuAlert("Özelliklerin tamamını seçmelisiniz");
    }

    //IF VARIANTS ARE NOT FULLY SELECTED SET ALERT
    if (
      variants.fullVariantsArray.length !== choosenVariants.length &&
      !variants.singleSku
    ) {
      return setVariantAlert({
        index: choosenVariants.length === 0 ? 0 : choosenVariants.length,
        message: "Özellik seçmelisiniz!",
      });
    }

    //IF QTY IS NOT SELECTED SET ALERT
    if (qty === 0 || qty === "0") {
      return setQtyAlert("Lütfen adet seçiniz");
    }

    //BUY ONE GET ONE FREE COMPARISON
    else if (
      buyOneGetOneFree &&
      isCampaignedProductInStock &&
      cartSkuItems.length >= 1 &&
      productId &&
      (variants.singleSku || multiSku) &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productLandings",
          discounted,
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );

      setDisableButton(true);
      return setBuyOneGetOneFreeRequested(true);
    } else if (buyOneGetOneFree && isCampaignedProductInStock) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productLandings",
          "",
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );

      setDisableButton(true);
      return setBuyOneGetOneFreeRequested(true);
    }

    //STANDART COMPARISON
    if (
      cartSkuItems.length === 0 &&
      productId &&
      (variants.singleSku || multiSku) &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productLandings",
          "",
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );
      setTimeout(() => {
        history.push(`/siparis-bilgileri-adim-1/2?appeal=${appealFromUrl}`);
      }, 2000);
    } else if (
      cartSkuItems.length >= 1 &&
      cartSkuItems[0].sku === (variants.singleSku || multiSku) &&
      productId &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productLandings",
          "",
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );
      setTimeout(() => {
        history.push(`/siparis-bilgileri-adim-1/2?appeal=${appealFromUrl}`);
      }, 2000);
    } else if (
      cartSkuItems.length >= 1 &&
      productId &&
      (variants.singleSku || multiSku) &&
      qty
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          productId,
          variants.singleSku || multiSku,
          qty,
          "productLandings",
          discounted,
          "",
          isDiscountValid && product?.timeLimitedDiscount.discountAmount
        )
      );

      setTimeout(() => {
        history.push(`/siparis-bilgileri-adim-1/2?appeal=${appealFromUrl}`);
      }, 2000);
    }
  }

  // Fill ErcModal content
  const freeAddToCart = [];
  freeAddToCart.push(
    <FreeProductAddToCart
      loadingCampaign={loadingCampaign}
      errorCampaign={errorCampaign}
      product={productCampaign}
      cartSkuItems={cartSkuItems}
      qty={qty}
      index={0}
      setVariantAlert={setVariantAlert}
      setNoSkuAlert={setNoSkuAlert}
      isThereApendingOrder={isPending && isPending.isTherePending}
      skipCartScreen={true}
    />
  );

  //************************************************************************************************//

  // IF PRODUCT IS BUY ONE GET ONE FREE, CLEAR CART BEFORE ADDING A NEW ITEM IN CART
  function clearCartSkuItems(whichCart) {
    if (whichCart === "OrderCartWithVariants") {
      setLoadingCart(false);
    } else {
      setLoadingCart(true);
    }

    dispatch({ type: CART_EMPTY_SKU });
  }

  // ADD TO CARD SEEMLESSLY AND GO TO ORDER PAGE
  const [isAddedInCart, setIsAddedInCart] = useState(false);
  const [loadingCart, setLoadingCart] = useState(false);
  const [appeal, setAppeal] = useState("");

  const [cartSkuItemsLength, setCartSkuItemsLength] = useState(0);
  const [addFreeProduct, setAddFreeProduct] = useState(""); // State to hold free product details to be dispatched in useEffect
  const [runOnlyOnce, setRunOnlyOnce] = useState(false); // This is the switch to avoid multiple dispatches in useEffect

  function handleBuyButton(
    cardQty,
    sku,
    campAppeal,
    freeProductId,
    freeProductSkus,
    buyOneGetOneFree,
    discounted
  ) {
    setCartSkuItemsLength(cartSkuItems.length);
    setRunOnlyOnce(true);
    setLoadingCart(true);
    setAppeal(campAppeal);
    let skuCode = sku.sku;

    // let discounted = true;
    // let free = true;
    // COMPARE FREE PRODUCT SKU WITH FREE PRODUCT PROVIDER SKU TO MATCH COLOR SETS
    const filtered =
      buyOneGetOneFree &&
      freeProductSkus.find((pSku) => {
        return (
          pSku.substring(pSku.length - 3, pSku.length) ===
          sku.sku.substring(sku.sku.length - 3, sku.sku.length)
        );
      });

    if (cardQty === 1) {
      // First add the main product in cart
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          product._id,
          skuCode,
          cardQty,
          "productLandings"
        )
      );

      // Than save free product details and add to cart in useEffect after main product has been added in cart
      if (filtered) {
        setAddFreeProduct({
          isThereApendingOrder: isPending && isPending.isTherePending,
          freeProductId,
          sku: filtered,
          qty: cardQty,
          buttonLocation: "productLandings",
          notDiscounted: false,
          free: true,
        });
      } else if (!filtered && freeProductSkus.length > 0 && buyOneGetOneFree) {
        //IF THERE IS NO FILTERED MATCH, FIRST IN ARRAY ADDED IN CART AS FREE PRODUCT
        setAddFreeProduct({
          isThereApendingOrder: isPending && isPending.isTherePending,
          freeProductId,
          sku: freeProductSkus[0],
          qty: cardQty,
          buttonLocation: "productLandings",
          notDiscounted: false,
          free: true,
        });
      }
      setTimeout(() => {
        setIsAddedInCart(true);
        setLoadingCart(false);
      }, 1500);
    } else if (cardQty > 1) {
      dispatch(
        actionToAddSkuItemInCart(
          isPending && isPending.isTherePending,
          product._id,
          skuCode,
          cardQty,
          "productLandings",
          discounted
        )
      );
      if (filtered) {
        setAddFreeProduct({
          isThereApendingOrder: isPending && isPending.isTherePending,
          freeProductId,
          sku: filtered,
          qty: cardQty,
          buttonLocation: "productLandings",
          notDiscounted: false,
          free: true,
        });
      } else if (!filtered && freeProductSkus.length > 0 && buyOneGetOneFree) {
        //IF THERE IS NO FILTERED MATCH, FIRST IN ARRAY ADDED IN CART AS FREE PRODUCT
        setAddFreeProduct({
          isThereApendingOrder: isPending.isTherePending,
          freeProductId,
          sku: freeProductSkus[0],
          qty: cardQty,
          buttonLocation: "productLandings",
          notDiscounted: false,
          free: true,
        });
      }
      setTimeout(() => {
        setIsAddedInCart(true);
        setLoadingCart(false);
      }, 1500);
    }
  }

  // If there is a main product with free product promotion than this useEffect run
  useEffect(() => {
    if (
      // This is the object that holds free product info
      addFreeProduct &&
      // This line makes sure that free product dispatched after main product to make sure that 0 priced item is after the main product in array
      cartSkuItems.length === 1 &&
      // This is a switch to make sure useEffect is run only once each time
      runOnlyOnce
    ) {
      dispatch(
        actionToAddSkuItemInCart(
          addFreeProduct.isThereApendingOrder,
          addFreeProduct.freeProductId,
          addFreeProduct.sku,
          addFreeProduct.qty,
          addFreeProduct.buttonLocation,
          addFreeProduct.notDiscounted,
          addFreeProduct.free
        )
      );

      // Switching back to false to stop multiple dispatches
      setRunOnlyOnce(false);
    }
  }, [dispatch, addFreeProduct, cartSkuItems, cartSkuItemsLength, runOnlyOnce]);

  // IF ADDED IN CART DIRECT TO ORDER PAGE
  useEffect(() => {
    if (isAddedInCart) {
      history.push(`/siparis-bilgileri-adim-1/2?appeal=${appeal}`);
    }
  }, [history, isAddedInCart, appeal]);

  //IF THERE IS A PHONE ITEM IN LOCAL STORAGE
  //IT IS PASSED TO ACTION AND DISPATCH A REQUEST
  //TO FIND OUT HOW MANY ORDERS ARE UNPAID
  //THAT IS RELATED TO THIS PHONE NUMBER
  useEffect(() => {
    const phoneNumber = JSON.parse(localStorage.getItem("checkUnpaid"));
    if (phoneNumber) {
      dispatch(actionOrderToCheckUnpaidOrders(phoneNumber));
    }
  }, [history, dispatch]);

  //REDUX STORE THAT HOLDS AUTHENTICATED USER INFO
  const authenticateUser = useSelector((state) => state.authenticateUser);
  const { authenticatedUser } = authenticateUser;

  // INJECT QnaUserForm INTO ErcModal
  const userForm = [];
  userForm.push(
    <QnaUserForm
      authenticatedUser={authenticatedUser}
      productId={productId}
      productName={product && product.name}
    />
  );

  // CALCULATE extraDiscountAmount
  const { extraDiscountAmount } = useCalculateExtraDiscount(
    cartSkuItems,
    isPending,
    createdFingerPrint,
    isDiscountValid
  );

  // UPDATE TOTAL AMOUNT IF THERE IS AN EXTRA DISCOUNT
  useUpdateCartExtraDiscountPrice(
    cartSkuItems,
    extraDiscountAmount,
    isDiscountValid
  );

  return (
    <>
      {loadingCart && <LoadingBlackOut />}
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        orderNowCards &&
        orderNowCards.length > 0 && (
          <div className="campaignProductLanding">
            <ErcModal
              modalTitleDivWidth={"85%"}
              modalTitle={() => ""}
              modalTitleFontSize={"1rem"}
              modalTitleLineHeight={"2rem"}
              contentTitleFontSize={"1.35rem"}
              contentTitle={""}
              content={freeAddToCart}
              modalParagFontSize={"1.25rem"}
              disableModalTitle={true}
              clickOutsideShouldWork={false}
              callThisFunctionInCloseModalFunction={() => {
                return [
                  // resetCartIfFreeProductNotAddedInCart(product),
                  dispatch({ type: CART_EMPTY_SKU }),

                  setDisableButton(false),
                ];
              }}
              popOnMount={
                buyOneGetOneFreeRequested &&
                !loading &&
                !loadingSkuData &&
                cartSkuItems.length > 0
                  ? "OPEN"
                  : "CLOSE"
              } // IF OPEN MODAL POPS IF CLOSE MODAL CLOSE
            />
            {product &&
              product.campaign.map((camp, index) => {
                return (
                  camp.urlExtension === urlExtension && (
                    <div key={`${index}-${index}`} className="w95p">
                      <Helmet>
                        <title>Şimdi Öğren | {camp.campaignTitle}</title>
                        <meta
                          name="description"
                          content={camp.campaignMetaDescription}
                        />
                        <meta
                          name="keywords"
                          content={camp.campaignMetaKeywords}
                        />
                        <meta name="author" content="beddo™ Marketing Team" />
                        <meta name="application-name" content="beddo™ ERP" />
                      </Helmet>

                      {camp.section.map((sect, index) => {
                        return (
                          (sect.isActive || sect.isActive === undefined) && (
                            <div
                              // key={sect.content[0]}
                              key={`${index}-${index}-${index}`}
                              className={sect.sectionType}
                            >
                              <div className="campaignProductLanding-first-flex-child">
                                <SectContent
                                  sect={sect}
                                  reviewsList={reviewsList}
                                  product={product}
                                  loadingCampaign={loadingCampaign}
                                  errorCampaign={errorCampaign}
                                  productCampaign={productCampaign}
                                  orderNowCards={orderNowCards}
                                  camp={camp}
                                  AdvantagesBoard={AdvantagesBoard}
                                  cartSkuItems={cartSkuItems}
                                  clearCartSkuItems={clearCartSkuItems}
                                  handleBuyButton={handleBuyButton}
                                  ShippingMessage={ShippingMessage}
                                  userForm={userForm}
                                  loadingSkuData={loadingSkuData}
                                  errorSkuData={errorSkuData}
                                  width={width}
                                  skuData={skuData}
                                  isPending={isPending}
                                  qty={qty}
                                  price={price}
                                  variants={variants}
                                  setChoosenVariants={setChoosenVariants}
                                  choosenVariants={choosenVariants}
                                  setVariantAlert={setVariantAlert}
                                  variantAlert={variantAlert}
                                  setNoSkuAlert={setNoSkuAlert}
                                  qtyAlert={qtyAlert}
                                  setQty={setQty}
                                  multiSku={multiSku}
                                  setQtyAlert={setQtyAlert}
                                  disableButton={disableButton}
                                  addToCartHandler={addToCartHandler}
                                  noSkuAlert={noSkuAlert}
                                  pendingPush={pendingPush}
                                  isDiscountValid={isDiscountValid}
                                  remainingTime={remainingTime}
                                />
                              </div>
                            </div>
                          )
                        );
                      })}
                    </div>
                  )
                );
              })}
          </div>
        )
      )}
    </>
  );
}
